<template>
  <div
    class="drag-warpper"
    @dragover.prevent="ondragover"
    @dragenter.prevent="ondragenter"
    @dragleave="ondragleave"
    @drop.capture="ondrop"
    @dragend="ondragend"
  >
    <slot>drag</slot>
  </div>
</template>

<script>
export default {
  props:['elIndex'],
  data() {
    return {
      draging: false
    };
  },
  methods: {
    ondragover(e) {

    },
    ondragenter(e){
      e.dataTransfer.dropEffect = 'copy'
    },
    ondragleave(e){
      e.dataTransfer.dropEffect = 'none'
    },
    ondrop(e){
      let dropValue = e.dataTransfer.getData('text')
      this.$emit('eldrop',{
        dropValue,
        elIndex:this.elIndex
      })
    },
    ondragend(e) {

    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
.drag-warpper {
  width: 100%;
}
</style>

